/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IRepoUploadCancelMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  uploadId: Types.Scalars['String']['input'];
  assetId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type IRepoUploadCancelMutation = {
  __typename?: 'Mutation';
  repoUploadCancel?: { __typename?: 'RepoUploadCancelPayload'; success: boolean; errors?: Array<string> | null } | null;
};

export const RepoUploadCancelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'repoUploadCancel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repoUploadCancel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uploadId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assetId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IRepoUploadCancelMutation, IRepoUploadCancelMutationVariables>;
